import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';
import { Profile } from '../_models/profile';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ProfileService extends ApiService {
  constructor(private http: Http) {
    super('api/profile/', http);
  }

  profile(): Observable<Profile> {
    return this.http.get(`${this.apiUrl}api/profile/`, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  saveProfile(profile): void {
    localStorage.removeItem('profile');
    localStorage.setItem('profile', JSON.stringify(profile));
  }

  changePassword(data: object): Observable<any> {
    return this.http
      .post(`${this.apiUrl}api/profile/change_password`, data, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  resetPassword(data: object): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/password/reset/`, data, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  resetPasswordConfirm(data: object): Observable<any> {
    return this.http
      .post(`${this.apiUrl}auth/password/reset/confirm/`, data, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  activate(data: object): Observable<any> {
    return this.http.post(`${this.apiUrl}api/profile/activate`, data, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/profile.service.ts